<div class="loader-outer-container" [ngClass]="data.horizontalPosition">
    <div class="loader-container">
        <div class="text">
            {{data.message}}
        </div>
        <mat-spinner style="margin-left: 16px;" [diameter]="24" color="accent" mode="indeterminate">
        </mat-spinner>
    </div>
</div>